module.exports = __webpack_public_path__ + "assets/img/3a19-gu.svg";